import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  IconButton,
  Slide,
  Typography,
} from "@mui/material";

import {
  Close as CloseIcon,
  Logout as LogoutIcon,
} from "@mui/icons-material";
import { COLOR_PRIMARY, COLOR_SECONDARY } from "../../../libs/constants";
import { useRouterStore } from "../../../libs/stores";
import { TransitionProps } from "@mui/material/transitions";
import React from "react";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface DialogCloseSessionProps {
  open: boolean;
  handleClose: () => void;
}
export const DialogCloseSession = ({
  open,
  handleClose,
}: DialogCloseSessionProps) => {
  const navigate = useNavigate();
  const reset = useRouterStore((state) => state.reset);
  const [isClosing, setClosing] = useState(false);
  const [isContinuo, setContinuo] = useState(false); 

  useEffect(() => {
    if (isContinuo) {
      handleCloseSession();
    }
  }, [isContinuo]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleCloseSession = () => {
    reset();
    localStorage.removeItem(process.env.REACT_APP_TOKEN!);
    localStorage.removeItem(process.env.REACT_APP_TOKEN_OPTIONS!);
    localStorage.removeItem(process.env.REACT_APP_TOKEN_ROUTER!);
    localStorage.removeItem(process.env.REACT_APP_TOKEN_ROUTER_BACKUP!);


    setTimeout(() => {
      navigate("/", { replace: true });
      setClosing(false);
      handleClose();
    }, 2000);
  };

  const handleContinuo = () => {
    setClosing(true);
    setTimeout(() => {
      setContinuo(true);
    }, 1000);
  };

  return (
    <Dialog
      open={open}
      onClose={isClosing ? undefined : handleClose}
      maxWidth="xs"
      fullWidth
      TransitionComponent={Transition}
      aria-labelledby="form-dialog-title"
      PaperProps={{ sx: { borderRadius: "12px", overflow: "hidden" } }}
      BackdropProps={{
        style: { backgroundColor: "rgba(3, 5, 33, 0.8)" },
      }}
    >
      <Box
        sx={{
          background: COLOR_PRIMARY,
          borderBottom: `4px solid ${COLOR_SECONDARY}`,
          px: 3,
          py: 2,
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          position: "relative",
        }}
      >
        <Box
          sx={{
            width: 44,
            height: 44,
            borderRadius: "50%",
            background: COLOR_SECONDARY,
            display: "grid",
            placeContent: "center",
            color: "#fff",
            flexShrink: 0,
          }}
        >
          <LogoutIcon />
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", lineHeight: 1.25, pr: 4 }}>
          <span id="form-dialog-title" style={{ color: "#fff", fontSize: 18, fontWeight: 600 }}>
            Cerrar sesión
          </span>
          <span style={{ color: "rgba(255,255,255,0.65)", fontSize: 12 }}>
            ¿Seguro que desea salir del sistema?
          </span>
        </Box>
        <IconButton
          onClick={handleClose}
          disabled={isClosing}
          size="small"
          aria-label="Cerrar"
          sx={{
            position: "absolute",
            top: 10,
            right: 10,
            width: 28,
            height: 28,
            color: "#fff",
            background: "linear-gradient(135deg, #ff4d4f, #cf1322)",
            border: "2px solid rgba(255,255,255,0.85)",
            boxShadow: "0 2px 8px rgba(207, 19, 34, 0.45)",
            "&:hover": { background: "linear-gradient(135deg, #ff7875, #cf1322)" },
          }}
        >
          <CloseIcon sx={{ fontSize: 16 }} />
        </IconButton>
      </Box>
      <Box sx={{ px: 3, py: 2.5, background: "#fff" }}>
        <Typography sx={{ color: "#1b1e2e", fontWeight: 600, mb: 1 }}>
          Al cerrar sesión:
        </Typography>
        <Box component="ul" sx={{ m: 0, pl: 2.5, color: "#5b6075", fontSize: 14, lineHeight: 1.7 }}>
          <li>Se finalizará su sesión actual en este equipo.</li>
          <li>Los cambios sin guardar se perderán.</li>
          <li>Deberá ingresar nuevamente con su usuario y contraseña.</li>
        </Box>
      </Box>
      <DialogActions sx={{ px: 3, pb: 2.5, pt: 0, background: "#fff", gap: 1 }}>
        <Button
          onClick={handleClose}
          disabled={isClosing}
          variant="outlined"
          sx={{
            color: COLOR_PRIMARY,
            borderColor: "#dfe2ea",
            fontWeight: 600,
            borderRadius: "8px",
            "&:hover": { borderColor: COLOR_PRIMARY, background: "transparent" },
          }}
        >
          Cancelar
        </Button>
        <Button
          onClick={handleContinuo}
          disabled={isClosing}
          variant="contained"
          disableElevation
          sx={{
            background: COLOR_SECONDARY,
            fontWeight: 600,
            borderRadius: "8px",
            "&:hover": { background: COLOR_SECONDARY, opacity: 0.9 },
          }}
          endIcon={
            isClosing ? (
              <CircularProgress size={18} sx={{ color: "#fff" }} />
            ) : (
              <LogoutIcon />
            )
          }
        >
          Cerrar sesión
        </Button>
      </DialogActions>
    </Dialog>
  );
};
